import angular from 'angular';
import { InvoiceLine } from '../model/invoiceLine';
import { DraftInvoice } from '../model/draftInvoice';
import { Invoice } from '../model/invoice';
import axios from 'axios';
import SignalRService from '@/shared/services/SignalRService';
import adminpulse from '@/shared/utils/adminpulse';
import moment from 'moment';
import DocumentService from '@/shared/services/DocumentService';
import { getZendeskUrl } from '@/shared/components/ZendeskHelp';
import userStorage from '@/shared/services/userStorage';
import guid, { guid1 } from '@/shared/utils/guid';

const emptyFilters = {
  relationId: null, // Guid?
  invoiceId: null, // Guid?
  isInvoice: null, // Bool?
  isPaid: null, // Bool?
  searchValue: null, // string
  associate: null, // Guid?
  assistantBackup: null, // Guid?
  assistant: null, // Guid?
  responsible: null, // Guid?
  billingUser: null, // UserId
  seniorUser: null, // UserId
  relationType: [], // int[]
  legalForms: [], // int[]
  withLabels: [], // string[]
  withoutLabels: [], // string[]
  invoiceDateFrom: moment
    .utc()
    .startOf('year')
    .toDate(), // date?
  invoiceDateTo: moment
    .utc()
    .endOf('year')
    .toDate(), // date?
  expiryDateFrom: null, // date?
  expiryDateTo: null, // date?
  status: {
    invoiceStatus: [],
    sendStatus: [],
    exportStatus: [],
    peppolExportStatus: [],
  },
  invoiceType: [], // int[]
  ownCompanies: [],
  paymentMethod: [],
  sendInvoiceStrategy: [],
  assignmentTemplateId: null, //Guid?
  invoiceStreamId: null, //Guid?
  invoiceScheduleTypes: [], //Guid[]
  deliveryFailed: null,
  withBillingErrors: null,
  relationGroups: [],
  crmTypes: [],
  showWrittenOffInternally: 0,
};

const columnSelectionStorageKey = 'InvoicingOverviewHiddenColumns';
angular
  .module('cloudX')
  .controller('InvoicingOverviewCtrl', [
    '$scope',
    '$timeout',
    '$state',
    '$q',
    '$filter',
    'resourceFactorySvc',
    'flySvc',
    'dataCache',
    'invoiceDialogsSvc',
    'invoicingSvc',
    'dialogsSvc',
    'transactionHttpSvc',
    '$anchorScroll',
    'appUrls',
    '$http',
    'Blob',
    'FileSaver',
    '$translate',
    '$window',
    'registrationService',
    'checkFeature',
    invoicingOverviewCtrl,
  ]);

function invoicingOverviewCtrl(
  $scope,
  $timeout,
  $state,
  $q,
  $filter,
  resourceFactorySvc,
  flySvc,
  dataCache,
  invoiceDialogsSvc,
  invoicingSvc,
  dialogsSvc,
  transactionHttpSvc,
  $anchorScroll,
  appUrls,
  $http,
  Blob,
  FileSaver,
  $translate,
  $window,
  registrationService,
  checkFeature,
) {
  var vm = this;
  var invoiceResource = resourceFactorySvc.get('invoice');
  vm.users = dataCache.getObject('user');
  vm.companies = dataCache.getArray('company');
  vm.isMultiCompany = vm.companies.length > 1;
  vm.showAssignments = dataCache.getArray('assignmentsEnabled');
  const detailRequests = {};
  vm.billingInformation = {}; //Key=relationId
  vm.isMasterTenant = dataCache.getArray('isMasterTenant');

  vm.showPaymentMonitoring = dataCache.showPaymentMonitoring;

  vm.getCompanySettings = companyId => {
    return dataCache.getCompanySettings(companyId);
  };

  vm.today = new Date();
  vm.year = moment.utc().year();
  vm.todayMin30 = new Date().setTime(vm.today.getTime() - 30 * 86400000);
  vm.wizardType = '0';
  vm.selectAll = false;
  vm.initFilters = true;
  vm.showAdvanceFilters = false;
  vm.period = 'year';
  vm.filters = { ...emptyFilters };
  vm.currentFilters = null;
  vm.customer = null;
  vm.hasFilter = false;
  vm.processingInvoicesInfo = invoicingSvc.getProcessingInvoicesInfo();

  vm.showInvoicingHistory = function(invoice) {
    return invoiceDialogsSvc.showInvoicingHistory(
      invoice.invoiceStream.id,
      invoice,
      invoice.customer.id,
    );
  };

  try {
    vm.isFileSaverSupported = !!new Blob();
  } catch (e) {
    vm.isFileSaverSupported = false;
  }

  var showError = function(error) {
    flySvc.error(error);
  };
  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };

  vm.refreshTotalsRequest = null;
  vm.refreshTotals = function(filters) {
    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.refreshTotalsRequest && vm.refreshTotalsRequest.$cancelRequest)
      vm.refreshTotalsRequest.$cancelRequest();
    vm.refreshTotalsRequest = invoiceResource.info(
      filters || { ...vm.currentFilters, ...((vm.table && vm.table.currentParams()) || {}) },
      function(data) {
        vm.dashboard = data;
      },
    );
  };

  vm.retrieveRequest = null;
  vm.retrieve = function(params) {
    //Cancel previous request, cancelling a completed request will have no effect
    if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
      vm.retrieveRequest.$cancelRequest();

    let requestParams = { ...(params || {}) };

    if (
      requestParams.sort &&
      angular.isArray(requestParams.sort) &&
      requestParams.sort[0] === 'date'
    ) {
      requestParams.sort.unshift('isProcessing');
    }

    vm.hasFilter = vm.hasFilters();

    vm.currentFilters = { ...vm.filters };

    // spread out object of status into separate props for ease of access on backend
    const urlCompatibleFilters = {
      ...vm.filters,
      ...vm.filters.status,
    };
    delete urlCompatibleFilters.status;

    sessionStorage.setItem(
      'InvoicingOverviewParams',
      JSON.stringify({
        tableParams: params,
        filterType: vm.filterType,
        filters: vm.currentFilters,
        period: vm.period,
        showAdvanceFilters: vm.showAdvanceFilters,
      }),
    );

    requestParams = { ...requestParams, ...urlCompatibleFilters };
    if (requestParams.page === 0) vm.refreshTotals(requestParams);
    vm.retrieveRequest = invoiceResource.query(requestParams);
    return vm.retrieveRequest.$promise.then(function(data) {
      vm.currentSearchParams = requestParams;

      if (requestParams.invoiceId && data && data.length === 1) {
        vm.toggleDetails(data[0]); // Load details when filter on 1 invoice
      }

      angular.forEach(data, function(el) {
        el.selected = vm.selectAll;
      });

      return data;
    });
  };

  const initStateParams = () => {
    if (!$state.params) return false;
    let hasParams = false;
    const {
      relation = null,
      relationId = null,
      invoiceId = null,
      filterType = null,
      dateFrom = null,
      dateUntil = null,
      period = null,
      invoiceStreamId = null,
      showWrittenOffInternally = null,
    } = $state.params;

    if (filterType && filterType > 0) {
      hasParams = true;
      vm.setFilter(filterType, true);
    }

    if (relation && relation.id) {
      hasParams = true;
      vm.filters.relationId = relation.id;
      if (relation.name) {
        vm.customer = { ...relation };
      }
    } else if (relationId) {
      hasParams = true;
      vm.filters.relationId = relationId;
    }
    if (invoiceStreamId) {
      hasParams = true;
      vm.filters.invoiceStreamId = invoiceStreamId;
    }
    if (dateFrom) {
      hasParams = true;
      vm.filters.invoiceDateFrom = moment.utc(dateFrom).toDate();
    }
    if (dateUntil) {
      hasParams = true;
      vm.filters.invoiceDateTo = moment.utc(dateUntil).toDate();
    }
    if (period) {
      hasParams = true;
      vm.setPeriod(period, true);
    }

    if (invoiceId) {
      hasParams = true;
      vm.filters.invoiceId = invoiceId;
    }
    if (showWrittenOffInternally !== null) {
      hasParams = true;
      vm.filters.showWrittenOffInternally = showWrittenOffInternally;
    }

    return hasParams;
  };
  const initCustomer = relationId => {
    $http.post(appUrls.api + '/api/Relation/Names', [relationId]).then(({ data }) => {
      if (data && data.length) {
        vm.customer = data[0];
      }
    });
  };

  const setParamsFromSessionStorage = () => {
    try {
      const sessionParams = JSON.parse(sessionStorage.getItem('InvoicingOverviewParams'));

      if (sessionParams) {
        const {
          filterType = null,
          filters = {},
          tableParams = {},
          showAdvanceFilters = false,
          period,
        } = sessionParams;
        vm.filterType = filterType;
        vm.filters = { ...vm.filters, ...filters };
        if (typeof vm.filters.invoiceDateFrom === 'string')
          vm.filters.invoiceDateFrom = moment.utc(vm.filters.invoiceDateFrom).toDate();
        if (typeof vm.filters.invoiceDateTo === 'string')
          vm.filters.invoiceDateTo = moment.utc(vm.filters.invoiceDateTo).toDate();
        if (typeof vm.filters.expiryDateFrom === 'string')
          vm.filters.expiryDateFrom = moment.utc(vm.filters.expiryDateFrom).toDate();
        if (typeof vm.filters.expiryDateTo === 'string')
          vm.filters.expiryDateTo = moment.utc(vm.filters.expiryDateTo).toDate();
        if (period) vm.setPeriod(period, true);

        vm.showAdvanceFilters = showAdvanceFilters;
        if (vm.table) {
          vm.table.initializeParams(tableParams);
        }
      }
    } catch (error) {
      console.error('Error while setting parameters from session storage');
      console.error(error);
    }
  };
  vm.setPeriod = function(period, noReload = false) {
    vm.period = period || 'year';

    switch (vm.period) {
      case 'none':
        vm.period = null;
        break;
      case 'month':
      case 'quarter':
      case 'year':
        vm.updateFilter(
          {
            invoiceDateFrom: moment
              .utc()
              .startOf(vm.period)
              .toDate(),
            invoiceDateTo: moment
              .utc()
              .endOf(vm.period)
              .toDate(),
          },
          noReload,
        );
        break;
      case 'prevMonth':
        vm.updateFilter(
          {
            invoiceDateFrom: moment
              .utc()
              .add(-1, 'months')
              .startOf('month')
              .toDate(),
            invoiceDateTo: moment
              .utc()
              .add(-1, 'months')
              .endOf('month')
              .toDate(),
          },
          noReload,
        );
        break;
      case 'prevQuarter':
        vm.updateFilter(
          {
            invoiceDateFrom: moment
              .utc()
              .add(-3, 'months')
              .startOf('quarter')
              .toDate(),
            invoiceDateTo: moment
              .utc()
              .add(-3, 'months')
              .endOf('quarter')
              .toDate(),
          },
          noReload,
        );
        break;
      case 'prevYear':
        vm.updateFilter(
          {
            invoiceDateFrom: moment
              .utc()
              .add(-1, 'year')
              .startOf('year')
              .toDate(),
            invoiceDateTo: moment
              .utc()
              .add(-1, 'year')
              .endOf('year')
              .toDate(),
          },
          noReload,
        );
        break;
      case 'all':
      default:
        vm.updateFilter(
          {
            invoiceDateFrom: null,
            invoiceDateTo: null,
          },
          noReload,
        );
        break;
    }
  };

  vm.details = {};

  vm.getUserName = function(userId) {
    if (userId === guid1) return $translate.instant('SystemUser');
    var user = vm.users[userId];
    if (!user) return '';
    return ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
  };

  var retrieveAttachments = function(invoice) {
    return $http
      .get(appUrls.documents + '/api/documents/links/' + invoice.id + '/2/1')
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          vm.details[invoice.id].attachments = result;
        }
        return null;
      })
      .catch(function(error) {
        showError(error);
        return null;
      });
  };

  vm.downloadAttachment = attachment => DocumentService.download(attachment.id);

  vm.toggleDetails = function(invoice, expandDetails) {
    if (
      invoice.loadingDetails &&
      detailRequests[invoice.id] &&
      detailRequests[invoice.id].$cancelRequest
    ) {
      detailRequests[invoice.id].$cancelRequest();
      invoice.loadingDetails = false;
      return;
    }

    if (!invoice.showDetails && !vm.details[invoice.id]?.completed) {
      invoice.loadingDetails = true;
      vm.details[invoice.id] = {};
      vm.details[invoice.id].attachments = [];

      if (invoice.hasAttachments) retrieveAttachments(invoice);

      detailRequests[invoice.id] = invoiceResource.lines(
        {
          id: invoice.id,
        },
        function(data) {
          detailRequests[invoice.id] = null;
          vm.details[invoice.id].lines = data.lines.map(function(l) {
            var line = new InvoiceLine(l);
            line.showRelation =
              line.registrations &&
              invoice.invoiceStream &&
              line.registrations.some(r => r.invoiceStreamId !== invoice.invoiceStream.id);
            if (typeof expandDetails !== 'undefined') {
              line.showDetails = !!expandDetails;
            }
            return line;
          });
          vm.details[invoice.id].payments = data.payments;
          vm.details[invoice.id].completed = true;
          invoice.showDetails = true;
          invoice.loadingDetails = false;
        },
        function(error) {
          detailRequests[invoice.id] = null;
          flySvc.error(error.data.code, error.data.parameters);
          invoice.loadingDetails = false;
        },
      );
    } else {
      invoice.showDetails = !invoice.showDetails;
      if (typeof expandDetails !== 'undefined') {
        vm.details[invoice.id].lines.forEach(line => (line.showDetails = !!expandDetails));
      }
    }
  };

  vm.copyInvoice = function(invoice) {
    if (!invoice || !invoice.id) return;
    invoiceResource.copy(
      {},
      [invoice.id],
      function(result) {
        $state.go('invoicing.draft', {
          relation: invoice.customer,
        });
      },
      showError,
    );
  };
  vm.creditInvoice = function(invoice) {
    if (!invoice || !invoice.id) return;
    invoiceResource.credit(
      {},
      [invoice.id],
      function(result) {
        $state.go('invoicing.draft', {
          relation: invoice.customer,
        });
      },
      showError,
    );
  };

  vm.selectAllChanged = function() {
    if (!vm.table || !vm.table.rows) return;
    angular.forEach(vm.table.rows, function(el) {
      if (!el.isProcessing) el.selected = vm.selectAll;
    });
  };

  vm.selectedCount = function() {
    if (!vm.table || !vm.table.rows) return 0;
    const total = (vm.dashboard && vm.dashboard.totalInvoices) || 0;
    const count = vm.table.rows.reduce(
      (cnt, inv) => cnt + (!inv.isProcessing && inv.selected !== vm.selectAll ? 1 : 0),
      0,
    );
    return vm.selectAll ? total - count : count;
  };

  vm.filterType = 0;
  vm.setFilter = function(type, noReload) {
    if (!vm.table) return;
    const emptyFilter = {
      status: {
        invoiceStatus: [],
        exportStatus: [],
        sendStatus: [],
        peppolExportStatus: [],
      },
      isInvoice: null,
      isPaid: null,
      expiryDateFrom: null,
      expiryDateTo: null,
      deliveryFailed: null,
      notExported: false,
    };
    if (type === 0) {
      vm.updateFilter(emptyFilter, noReload);
    } else if (type === 1) {
      vm.updateFilter(
        {
          ...emptyFilter,
          isInvoice: true,
          isPaid: false,
          expiryDateFrom: null,
          expiryDateTo: null,
        },
        noReload,
      );
    } else if (type === 2) {
      vm.updateFilter(
        {
          ...emptyFilter,
          isInvoice: true,
          isPaid: false,
          expiryDateFrom: moment
            .utc()
            .startOf('day')
            .add(-1, 'months')
            .toDate(),
          expiryDateTo: moment
            .utc()
            .startOf('day')
            .toDate(),
        },
        noReload,
      );
    } else if (type === 3) {
      vm.updateFilter(
        {
          ...emptyFilter,
          isInvoice: true,
          isPaid: false,
          expiryDateFrom: null,
          expiryDateTo: moment
            .utc()
            .startOf('day')
            .add(-1, 'months')
            .toDate(),
        },
        noReload,
      );
    } else if (type === 5) {
      vm.updateFilter(
        {
          ...emptyFilter,
          status: {
            ...emptyFilter.status,
            sendStatus: [0],
            peppolExportStatus: [0, 3], // not exported & export failed
          },
        },
        noReload,
      );
    } else if (type === 6) {
      vm.updateFilter(
        {
          ...emptyFilter,
          status: {
            ...emptyFilter.status,
            exportStatus: [0],
          },
        },
        noReload,
      );
    } else if (type === 7) {
      vm.updateFilter(
        {
          ...emptyFilter,
          deliveryFailed: true,
        },
        noReload,
      );
    } else if (type === 8) {
      vm.updateFilter(
        {
          ...emptyFilter,
          notExported: true,
        },
        noReload,
      );
    }

    vm.filterType = type;
  };
  vm.updateFilter = function(value, noReload) {
    if (value) {
      vm.filters = { ...vm.filters, ...value };
    }

    if (!noReload && !angular.equals(vm.currentFilters, vm.filters)) {
      //vm.filterType = 999; // Custom filter
      vm.table.reload();
    }
  };

  vm.customerFilterChanged = function(value) {
    const cust = typeof value === 'undefined' ? vm.customer : value;
    vm.updateFilter({ relationId: cust && cust.id ? cust.id : null, invoiceStreamId: null });
  };

  vm.hasFilters = function() {
    if (vm.table && vm.table.tableInfo && !angular.equals(vm.table.tableInfo.filters, {}))
      return true;
    return !angular.equals(vm.filters, emptyFilters);
  };
  vm.clearFilters = function() {
    if (vm.table) vm.table.clearFilter();
    vm.filters = { ...emptyFilters };
    vm.period = 'year';
    vm.filterType = -1;
    vm.customer = null;
    vm.table.reload();
  };

  vm.downloadSeparatePdf = function(dl, documentPdfId) {
    if (typeof dl === 'undefined') dl = true;
    if (!documentPdfId) {
      if (!vm.table || !vm.table.rows) return;
      var invoices = vm.table.rows.filter(el => el.selected && !el.isProcessing);
      if (invoices.length > 10) {
        flySvc.warning('msgOpenInvoicesInTabsIsLimited');
      } else {
        angular.forEach(invoices, function(el) {
          if (el.documentPdfId) {
            DocumentService.open(el.documentPdfId);
          } else {
            flySvc.error('msgCouldNotFindInvoicePdf');
          }
        });
      }
    } else {
      if (!documentPdfId) {
        flySvc.error('msgCouldNotFindInvoicePdf');
        return;
      }
      DocumentService.open(documentPdfId);
    }
  };

  vm.downloadInvoices = function(invoiceId) {
    if (vm.downloading) return;
    if (vm.selectedCount() === 0 && !invoiceId) {
      return;
    }

    let batchParams = {};

    if (invoiceId) {
      batchParams = {
        selectAll: false,
        invoiceIds: [invoiceId],
      };
    } else {
      batchParams = vm.getBatchSelectionParams();
    }

    const params = { ...vm.currentSearchParams };

    const connectionId = SignalRService.getConnectionId();

    vm.downloading = true;
    $http
      .post(appUrls.api + '/api/Invoice/zip?connectionId=' + connectionId, batchParams, { params })
      .then(
        function(result) {
          vm.downloading = false;
          flySvc.message('msgDownloadingFile');
        },
        function(error) {
          flySvc.message('msgCreateFileInBackgroundFailed');
          vm.downloading = false;
        },
      );
  };

  vm.renderInvoiceDetail = function(invoiceId) {
    dialogsSvc
      .showYesNoCancel(
        'msgIncludeNonBillableRegistrationsTitle',
        'msgIncludeNonBillableRegistrationsMsg',
      )
      .then(
        function(includeNonBillableRegistrations) {
          if (includeNonBillableRegistrations === null) return false; // Cancel changes

          const endpoint =
            appUrls.api +
            '/api/invoice/renderInvoiceDetail?id=' +
            invoiceId +
            '&includeNonBillableRegistrations=' +
            includeNonBillableRegistrations;

          return $http
            .get(endpoint, {
              responseType: 'arraybuffer',
            })
            .then(
              result => {
                const contentDisposition = result.headers('Content-Disposition');
                const filename = adminpulse.getFileNameFromHeader(contentDisposition);
                var fileType = result.headers('Content-Type');

                var blob = new Blob([result.data], { type: 'application/pdf' });
                if (blob) {
                  FileSaver.saveAs(blob, filename);
                }
              },
              error => {
                showArrayBufferError(error);
              },
            );
        },
        function() {
          return false; // Cancel changes
        },
      );
  };

  vm.export = function() {
    let companyId = vm.getSingleCompanyId();

    if (!companyId) {
      flySvc.message('msgExporterMultipleCompanies');
      return;
    }

    if (vm.loadingExporter) return;
    vm.loadingExporter = true;
    const batchParams = vm.getBatchSelectionParams();
    const params = {
      ...vm.currentSearchParams,
      onlyNotExportedInvoices: vm.selectedCount() === 0,
    };

    invoiceResource.export(
      params,
      batchParams,
      function({ result }) {
        vm.loadingExporter = false;
        if (result.containsAlreadyExportedInvoices) {
          dialogsSvc.showOkCancel('WarningTitle', 'msgSelectionContainedAlreadyExportedInvoices');
        }
        if (result.exportedUsingAdminConnect) {
          flySvc.success('msgInvoicesSentToConnect');
          return;
        }
        const config = { headers: { 'Content-Type': 'multipart/form-data' } };

        const formData = new FormData();
        var BASE_URL = 'https://www.admin-export.be/';
        formData.append('id', companyId);
        formData.append('file', new Blob([result.exporterXml], { type: 'application/xml' }));

        axios({
          method: 'post',
          url: BASE_URL + 'Plugin/External',
          data: formData,
        })
          .then(function(response) {
            window.open(BASE_URL + '?id=' + companyId + '&file=1');
          })
          .catch(function(response) {
            if (response.request.readyState == 4) {
              //There will be a cross-domain error, so don't validate the status.
              window.open(BASE_URL + '?id=' + companyId + '&file=1');
            } else {
              console.error('Error : ', response);
            }
          });
      },
      function(error) {
        vm.loadingExporter = false;
        if (error.data.code != 11033) return showError(error);
        vm.table.reload();
        return flySvc.action('ErrorTitle', 'msgExporterMissingAccNr');
      },
    );
  };

  vm.quickSend = function(invoice) {
    const useMailEditor = dataCache.getCompanySettings(invoice.companyId).sendInvoiceUseMailEditor;

    if (!useMailEditor) {
      if (invoice.canSend) {
        invoice.quickSending = true;

        $http.post(appUrls.api + `/api/invoice/quicksend/${invoice.id}`).then(
          function(result) {
            invoice.quickSending = false;
            flySvc.success();
          },
          function(error) {
            invoice.quickSending = false;
            showError(error);
          },
        );
        return;
      } else {
        flySvc.message('msgCannotSendNoRelationEmail');
      }
    }

    //Open in editor
    vm.openMailDialog(invoice, true);
  };

  vm.openMailDialog = function(invoice, useSendInvoiceStrategy) {
    if (!vm.table || !vm.table.rows) return false;

    invoiceDialogsSvc.mailInvoice(invoice, useSendInvoiceStrategy).then(function(result) {
      if (result) {
        flySvc.success('msgSingleInvoiceEmailSent', {
          relation: $filter('relationName')(invoice.customer),
        });
      }
    });

    return true;
  };

  vm.mergePdf = function() {
    if (vm.openingMergedPdf) return;
    if (vm.selectedCount() === 0) return;
    const batchParams = vm.getBatchSelectionParams();
    const params = { ...vm.currentSearchParams };

    vm.openingMergedPdf = true;
    const connectionId = SignalRService.getConnectionId();
    $http
      .post(appUrls.api + '/api/invoice/mergedpdf?connectionId=' + connectionId, batchParams, {
        responseType: 'arraybuffer',
        params,
      })
      .then(
        function(result) {
          vm.openingMergedPdf = false;
          flySvc.message('msgDownloadingFile');
        },
        function(error) {
          vm.openingMergedPdf = false;
          showError(error);
        },
      );
  };

  vm.batchMarkSent = function() {
    if (vm.markingSent) return;
    if (vm.selectedCount() === 0) return;
    const batchParams = vm.getBatchSelectionParams();
    const params = { ...vm.currentSearchParams };

    vm.markingSent = true;
    $http
      .post(appUrls.api + '/api/invoice/BatchMarkSent', batchParams, {
        params,
      })
      .then(
        function({ data }) {
          vm.markingSent = false;

          if (!data) {
            flySvc.success('msgInvoicesWillBeMarkedAsSent');
          } else {
            if (data.length > 0) {
              flySvc.success('msgConfirmChange');
              invoicesUpdatedHandler(data);
            }
          }
        },
        function(error) {
          vm.markingSent = false;
          showError(error);
        },
      );
  };

  vm.batchMarkExported = function() {
    if (vm.markingExported) return;
    if (vm.selectedCount() === 0) return;
    const batchParams = vm.getBatchSelectionParams();
    const params = { ...vm.currentSearchParams };

    vm.markingExported = true;
    $http
      .post(appUrls.api + '/api/invoice/BatchMarkExported', batchParams, {
        params,
      })
      .then(
        function({ data }) {
          vm.markingExported = false;

          if (!data) {
            flySvc.success('msgInvoicesWillBeMarkedAsExported');
          } else {
            if (data.length > 0) {
              flySvc.success('msgConfirmChange');
              invoicesUpdatedHandler(data);
            }
          }
        },
        function(error) {
          vm.markingExported = false;
          showError(error);
        },
      );
  };

  vm.batchMarkPaid = function() {
    if (vm.markingPaid) return;
    if (vm.selectedCount() === 0) return;
    const batchParams = vm.getBatchSelectionParams();
    const params = { ...vm.currentSearchParams };

    vm.markingPaid = true;
    $http
      .post(appUrls.api + '/api/invoice/BatchMarkPaid', batchParams, {
        params,
      })
      .then(
        function({ data }) {
          vm.markingPaid = false;
          flySvc.success('msgInvoicesWillBeMarkedAsPaid');
        },
        function(error) {
          vm.markingPaid = false;
          showError(error);
        },
      );
  };

  vm.batchClearExportStatus = function() {
    if (vm.clearingExportStatus) return;
    if (vm.selectedCount() === 0) return;
    const batchParams = vm.getBatchSelectionParams();
    const params = { ...vm.currentSearchParams };

    vm.clearingExportStatus = true;
    $http
      .post(appUrls.api + '/api/invoice/BatchClearExportStatus', batchParams, {
        params,
      })
      .then(
        function({ data }) {
          vm.clearingExportStatus = false;
          flySvc.success('msgInvoiceExportStatusWillBeCleared');
        },
        function(error) {
          vm.clearingExportStatus = false;
          showError(error);
        },
      );
  };

  vm.addPayment = function(invoice) {
    if (!(invoice.status > 0 && invoice.dueAmount() !== 0)) return;
    invoiceDialogsSvc.newInvoicePayment(invoice, null).then(function(payment) {
      if (vm.details[invoice.id] && vm.details[invoice.id].payments)
        vm.details[invoice.id].payments.push(payment);

      if (payment.isCreditNote) {
        invoice.paidAmount += payment.amount * (invoice.isInvoice ? 1 : -1);
        var otherId = invoice.isInvoice ? payment.referenceId : payment.invoiceId;
        var other = vm.table.rows.find(function(i) {
          return i.id === otherId;
        });
        if (other) {
          other.paidAmount += payment.amount * (other.isInvoice ? 1 : -1);
        }
        if (vm.details[otherId]) {
          vm.details[otherId].payments.push(
            angular.extend(angular.copy(payment), {
              remark: invoice.number,
              referenceId: invoice.id,
            }),
          );
        }
      } else {
        invoice.paidAmount += payment.amount;
      }

      vm.refreshTotals();
    });
  };
  vm.editPayment = function(invoice, payment, prop, value) {
    if (payment[prop] === value) return false;
    var copy = angular.copy(payment);
    copy[prop] = value;

    return (payment.isCreditNote
      ? transactionHttpSvc.updateLink
      : transactionHttpSvc.updatePayment)(copy).then(
      function() {
        if (payment.isCreditNote) {
          invoice.paidAmount += (copy.amount - payment.amount) * (invoice.isInvoice ? 1 : -1);
          var otherId = invoice.isInvoice ? payment.referenceId : payment.invoiceId;
          var other = vm.table.rows.find(function(i) {
            return i.id === otherId;
          });
          if (other) {
            other.paidAmount += (copy.amount - payment.amount) * (other.isInvoice ? 1 : -1);
          }
          if (vm.details[otherId]) {
            var p = vm.details[otherId].payments.find(function(p) {
              return (
                p.isCreditNote &&
                (invoice.isInvoice ? p.invoiceId === invoice.id : p.referenceId === invoice.id)
              );
            });
            if (p) p.amount = copy.amount;
          }
        } else {
          invoice.paidAmount += copy.amount - payment.amount;
        }
        payment[prop] = value;
        vm.refreshTotals();
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        throw error; //rethrow error for xeditable
      },
    );
  };
  vm.deletePayment = function(invoice, payment) {
    if (payment.id)
      dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeletePayment').then(function() {
        (payment.isCreditNote ? transactionHttpSvc.removeLink : transactionHttpSvc.removePayment)(
          payment.id,
        ).then(function() {
          var idx = vm.details[invoice.id].payments.indexOf(payment);
          if (idx >= 0) vm.details[invoice.id].payments.splice(idx, 1);
          if (payment.isCreditNote) {
            invoice.paidAmount -= payment.amount * (invoice.isInvoice ? 1 : -1);
            var otherId = invoice.isInvoice ? payment.referenceId : payment.invoiceId;
            var other = vm.table.rows.find(function(i) {
              return i.id === otherId;
            });
            if (other) {
              other.paidAmount -= payment.amount * (other.isInvoice ? 1 : -1);
            }
            if (vm.details[otherId]) {
              var idx2 = vm.details[otherId].payments.findIndex(function(p) {
                return (
                  p.isCreditNote &&
                  (invoice.isInvoice ? p.invoiceId === invoice.id : p.referenceId === invoice.id)
                );
              });
              if (idx2 >= 0) vm.details[otherId].payments.splice(idx2, 1);
            }
          } else {
            invoice.paidAmount -= payment.amount;
            vm.refreshTotals();
          }
        }, showError);
      });
  };

  vm.showEmailHistory = function(invoice) {
    invoiceDialogsSvc.mailHistory(invoice).then(function(result) {
      if (result) {
        invoiceDialogsSvc.invoiceAudit(invoice);
      }
    });
  };
  vm.showInvoiceAudit = function(invoice) {
    invoiceDialogsSvc.invoiceAudit(invoice);
  };
  vm.mailReminder = function(invoice) {
    invoiceDialogsSvc.mailReminder(invoice);
  };

  vm.markSent = function(invoice) {
    invoiceResource.markSent(
      {
        id: invoice.id,
      },
      null,
      function(data) {
        if (data) {
          invoice.sentOn = data.sentOn;
          invoice.sentBy = data.sentBy;
          invoice.emailStatus = data.emailStatus;
          vm.dashboard.nrNotSentInvoices--;
          flySvc.success(
            invoice.isInvoice ? 'msgInvoiceMarkedAsSent' : 'msgCreditNoteMarkedAsSent',
          );
        }
      },
      showError,
    );
  };

  vm.markExported = function(invoice) {
    invoiceResource.markExported(
      {
        id: invoice.id,
      },
      null,
      function(data) {
        if (data) {
          angular.extend(invoice, data);

          flySvc.success('SuccessTitle');
        }
      },
      showError,
    );
  };

  vm.clearExportStatus = function(invoice) {
    invoice.loading = true;
    invoiceResource.clearExportStatus(
      {
        id: invoice.id,
      },
      null,
      function(data) {
        invoice.loading = false;
        if (data) {
          angular.extend(invoice, data);

          flySvc.success('SuccessTitle');
        }
      },
      function(error) {
        invoice.loading = true;
        showError(error);
      },
    );
  };

  vm.editInvoice = function(invoice) {
    if (
      dataCache.getCompanySettings(invoice.companyId) &&
      dataCache.getCompanySettings(invoice.companyId).invoicePaymentProvider === 2
    ) {
      flySvc.message('msgEditInvoiceTwikeyWarning', null, 20000);
      return;
    }

    if (!invoice || !invoice.id || invoice.isProcessing || invoice.state & 4) return;
    invoiceResource.initEdit(
      {
        id2: invoice.id,
      },
      function(data) {
        var copy = new DraftInvoice(data.invoice);
        copy.invoiceLines = data.invoiceLines.map(function(l) {
          return new InvoiceLine(l);
        });
        invoiceDialogsSvc.editInvoice(copy).then(function(result) {
          if (result) {
            vm.details[invoice.id] = null;
            vm.table.reload();
          }
        });
      },
      showError,
    );
  };

  vm.unnumberInvoice = function(invoice) {
    const hasPaymentProvider =
      dataCache.getCompanySettings(invoice.companyId) &&
      dataCache.getCompanySettings(invoice.companyId).invoicePaymentProvider > 0;

    const message = hasPaymentProvider
      ? 'comfirmUnnumberInvoiceMessagePaymentProvider'
      : 'comfirmUnnumberInvoiceMessage';

    dialogsSvc.showYesNo('comfirmUnnumberInvoiceTitle', message).then(function() {
      invoiceResource.unnumber(
        { id: invoice.id },
        function(data) {
          flySvc.success('msgInvoiceSuccessfullyUnnumbered');

          if (vm.table.rows) {
            var idx = vm.table.rows.findIndex(x => x.id === invoice.id);
            if (idx >= 0) vm.table.rows.splice(idx, 1);
          }
        },
        error => {
          if (error.data.code === 11065) {
            const zendeskUrl = getZendeskUrl(
              '6009136333970',
              $translate.use(),
              false,
              '#h_01GANHWVF8WWNHP34GPQFQTVN2',
            );
            flySvc.custom({
              toastrType: 'error',
              titleMessage: '',
              content: $filter('translateList')(error.data.code, error.data.type),
              onClick: () => $window.open(zendeskUrl, '_blank'),
            });
          } else {
            flySvc.error(error);
          }
        },
      );
    });
  };

  vm.goToInvoice = function(invoiceId, showDetails) {
    var invoice = vm.table.rows.find(function(inv) {
      return inv.id === invoiceId;
    });
    if (invoice) {
      if (typeof showDetails !== 'undefined' && invoice.showDetails !== !!showDetails)
        vm.toggleDetails(invoice);
      $timeout(function() {
        $anchorScroll('inv-' + invoiceId);
      }, 100);
    } else {
      invoiceResource.query(
        {
          filter: {
            id: {
              items: [invoiceId],
            },
          },
        },
        function(data) {
          if (data && data.length === 1) {
            var el = data[0];
            if (!el.isProcessing && !el.loadingDetails && !el.showDetails) vm.toggleDetails(el);
            vm.table.rows.push(el);
            $timeout(function() {
              $anchorScroll('inv-' + invoiceId);
            }, 100);
          }
        },
      );
    }
  };

  vm.setHasAttachments = function(invoice, hasAttachments) {
    var model = angular.copy(invoice);
    model.hasAttachments = hasAttachments;

    return $http
      .put(appUrls.api + '/api/invoice/updateHasAttachments', model)
      .then(function(response) {
        var result = response.data;
        return '';
      })
      .catch(function(error) {
        showError(error);
        return null;
      });
  };

  vm.searchRelationOnPeppolNetwork = function(invoice) {
    invoice.loading = true;

    return $http
      .post(appUrls.api + '/api/relation/SearchRelationInPeppol?id=' + invoice.customer.id)
      .then(function(response) {
        var data = response.data;
        invoice.loading = false;
        invoice.relationPeppolStatus = data.peppolStatus;

        if (data.peppolStatus === 1) {
          flySvc.error('msgRelationNotFoundOnPeppolNetwork');
        } else if (data.peppolStatus === 2) {
          flySvc.warning('msgRelationFoundOnPeppolNetworkButNoSupportedDocumentFormats');
        } else if (data.peppolStatus === 3) {
          // ask the user if he wants to switch the invoice strategy to peppol if the relation was found on peppol network
          if (data.currentSendInvoiceStrategy != 5) {
            return dialogsSvc
              .showYesNo('SuccessTitle', 'msgSwitchInvoiceStrategyToPeppolAfterLookup')
              .then(function() {
                return switchInvoiceStrategyToPeppol(invoice.customer.id);
              });
          } else {
            flySvc.success('msgRelationFoundOnPeppolNetwork');
          }
        }
        return '';
      })
      .catch(function(error) {
        invoice.loading = false;
        showError(error);
        return null;
      });
  };

  vm.sendViaPeppol = function(invoice) {
    invoice.loading = true;

    const doSendInvoiceViaPeppol = () =>
      $http
        .post(appUrls.api + `/api/invoice/SendViaPeppol?id=${invoice.id}`)
        .then(function(response) {
          var result = response.data;
          invoice.loading = false;
          flySvc.success('msgInvoiceSentViaPeppol');
          if (result) {
            return dialogsSvc
              .showYesNo('SuccessTitle', 'msgSwitchInvoiceStrategyToPeppolAfterInvoiceSent')
              .then(function() {
                return switchInvoiceStrategyToPeppol(invoice.customer.id);
              });
          }
          return '';
        })
        .catch(function(error) {
          invoice.loading = false;
          const { code, type } = error;
          if (type && type.toLowerCase() === 'connectexceptioncode' && code === 603) {
            // if no peppol config found: guide user to connect page
            flySvc.action(null, flySvc.getErrorMsg(code, null, null, type), function() {
              $window.open(`${appUrls.connect}?companyId=${invoice.companyId}`, '_blank');
            });
          } else {
            showError(error);
          }
          return null;
        });

    if (invoice.peppolExportStatus === 2) {
      return dialogsSvc.showYesNo('WarningTitle', 'msgInvoiceAlreadyExportedViaPeppol').then(
        function() {
          return doSendInvoiceViaPeppol();
        },
        () => {
          invoice.loading = false;
        },
      );
    } else {
      return doSendInvoiceViaPeppol();
    }

    return;
  };

  var switchInvoiceStrategyToPeppol = relationId => {
    return $http
      .put(
        appUrls.api +
          `/api/relation/ModifySendInvoiceStrategy?id=${relationId}&sendInvoiceStrategy=5`,
      )
      .then(function(response) {
        var result = response.data;
        flySvc.success('SuccessTitle');
        return '';
      })
      .catch(function(error) {
        showError(error);
        return null;
      });
  };

  vm.uploadAttachment = function(files, invoice) {
    if (!files || files.length < 1) return;

    var newAttachments = [];

    var formData = new FormData();
    formData.append('documentType', 1);
    formData.append('documentLinkType', 2);
    formData.append('linkId', invoice.id);
    formData.append('relationId', invoice.customer.id);

    files.forEach(function(file) {
      var attachment = {
        name: file.name,
        scanStatus: 1,
        invoiceId: invoice.id,
      };
      if (!vm.details[invoice.id] || !vm.details[invoice.id].attachments) {
        vm.toggleDetails(invoice);
      }
      if (vm.details[invoice.id] && vm.details[invoice.id].attachments)
        vm.details[invoice.id].attachments.push(attachment);
      newAttachments.push(attachment);
      formData.append('data', file.data);
    });

    $http({
      method: 'POST',
      url: appUrls.documents + '/api/documents/',
      headers: {
        'Content-Type': undefined,
      },
      data: formData,
    })
      .then(function(response) {
        var result = response.data;
        if (result && result.length > 0) {
          result.forEach(function(file) {
            var attachment = newAttachments.find(function(el) {
              return el.name === file.name;
            });
            if (attachment) angular.extend(attachment, file);
          });
          if (
            !vm.details[invoice.id].hasAttachments &&
            newAttachments.some(function(el) {
              return el.scanStatus === 2;
            })
          )
            vm.setHasAttachments(invoice, true);
        }
      })
      .catch(function(error) {
        newAttachments.forEach(function(attachment) {
          if (vm.details[invoice.id] && vm.details[invoice.id].attachments) {
            var index = vm.details[invoice.id].attachments.indexOf(attachment);
            if (index >= 0) {
              vm.details[invoice.id].attachments.splice(index, 1);
            }
          }
        });

        flySvc.error(error);
        return '';
      });
  };

  vm.deleteAttachment = function(invoice, attachment) {
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'confirmDeleteInvoiceAttachment').then(function() {
      $http
        .delete(appUrls.documents + '/api/documents/' + attachment.id)
        .then(function(response) {
          var result = response.data;
          var index = vm.details[invoice.id].attachments.indexOf(attachment);
          if (index >= 0) {
            vm.details[invoice.id].attachments.splice(index, 1);
          }
          if (vm.details[invoice.id].attachments.length === 0) vm.setHasAttachments(invoice, false);
        })
        .catch(function(error) {
          flySvc.error(error);
          return '';
        });
    });
  };

  const invoiceUpdatedHandler = invoice => {
    if (!vm.table || !vm.table.rows) return;
    $timeout(function() {
      var updatedInvoice = new Invoice(invoice);
      var oldInvoice = vm.table.rows.find(function(inv) {
        return inv.id === invoice.id;
      });

      if (!!oldInvoice) {
        if (oldInvoice.isProcessing && !updatedInvoice.isProcessing) {
          updatedInvoice.selected = vm.selectAll;
        }
        angular.extend(oldInvoice, updatedInvoice);
      }
    }, 0);
  };

  const invoicesUpdatedHandler = invoices => {
    if (invoices && invoices.length) {
      for (let i = 0; i < invoices.length; i++) {
        const invoice = invoices[i];
        invoiceUpdatedHandler(invoice);
      }
    }
  };

  vm.createInvoiceReport = function() {
    vm.creatingReport = true;

    const requestQueryParams = {
      ...vm.currentSearchParams,
      culture: $translate.use(),
      connectionId: SignalRService.getConnectionId(),
    };

    const requestBody = vm.getBatchSelectionParams();

    return invoiceResource.report(requestQueryParams, requestBody).$promise.then(
      function() {
        vm.creatingReport = false;
        flySvc.success('ExportToExcelStarted');
      },
      function(error) {
        vm.creatingReport = false;
        showError(error);
      },
    );
  };
  vm.createInvoiceLinesReport = function() {
    vm.creatingReport = true;

    const requestQueryParams = {
      ...vm.currentSearchParams,
      culture: $translate.use(),
      connectionId: SignalRService.getConnectionId(),
    };

    const requestBody = vm.getBatchSelectionParams();

    return invoiceResource.linesReport(requestQueryParams, requestBody).$promise.then(
      function() {
        vm.creatingReport = false;
        flySvc.success('ExportToExcelStarted');
      },
      function(error) {
        vm.creatingReport = false;
        showError(error);
      },
    );
  };

  const documentScannedHandler = document => {
    if (!document || !document.id) return;

    Object.keys(vm.details).forEach(function(key, index) {
      if (vm.details[key] && vm.details[key].attachments) {
        for (var i = 0; i < vm.details[key].attachments.length; i++) {
          var attachment = vm.details[key].attachments[i];
          if (attachment.id === document.id) {
            angular.extend(attachment, document);

            var invoice = vm.table.rows.find(function(invoice) {
              return invoice.id === key;
            });

            if (invoice && !invoice.hasAttachments && attachment.scanStatus === 2)
              vm.setHasAttachments(invoice, true);

            return;
          }
        }
      }
    });
  };
  const refreshProcessingInvoices = () => {
    $timeout(() => invoicingSvc.reloadProcessingInvoicesInfo(), 0);
  };

  SignalRService.subscribe('invoiceUpdated', invoiceUpdatedHandler);
  SignalRService.subscribe('invoicesUpdated', invoicesUpdatedHandler);
  SignalRService.subscribe('refreshProcessingInvoices', refreshProcessingInvoices);

  $scope.$on('$destroy', function() {
    SignalRService.unsubscribe('invoiceUpdated', invoiceUpdatedHandler);
    SignalRService.unsubscribe('invoicesUpdated', invoicesUpdatedHandler);
    SignalRService.unsubscribe('refreshProcessingInvoices', refreshProcessingInvoices);
    if (vm.refreshTotalsRequest && vm.refreshTotalsRequest.$cancelRequest)
      vm.refreshTotalsRequest.$cancelRequest();
    if (vm.retrieveRequest && vm.retrieveRequest.$cancelRequest)
      vm.retrieveRequest.$cancelRequest();
  });

  vm.getErrorMsg = flySvc.getErrorMsg;

  vm.fixErrors = function(invoice) {
    if (invoice.exportErrors.length) {
      $state.go('relations.detail', {
        relId: invoice.customer.id,
      });
    }
  };

  vm.toggleAdvanceFilters = function() {
    vm.showAdvanceFilters = !vm.showAdvanceFilters;
    const params = JSON.parse(sessionStorage.getItem('InvoicingOverviewParams')) || {};

    sessionStorage.setItem(
      'InvoicingOverviewParams',
      JSON.stringify({
        ...params,
        showAdvanceFilters: vm.showAdvanceFilters,
      }),
    );
  };

  vm.getBatchSelectionParams = function() {
    return {
      selectAll: vm.selectAll,
      invoiceIds:
        vm.table && vm.table.rows
          ? vm.table.rows
              .filter(inv => !inv.isProcessing && !!inv.selected !== vm.selectAll)
              .map(inv => inv.id)
          : [],
    };
  };

  vm.batchSendViaEmail = function() {
    if (vm.selectedCount() === 0) return;

    const params = { ...vm.currentSearchParams };
    const batchParams = vm.getBatchSelectionParams();
    let languages = [];
    const companyId = vm.getSingleCompanyId();

    if (!vm.selectAll) {
      languages = Object.keys(
        vm.table.rows
          .filter(el => el.selected && !el.isProcessing)
          .reduce((l, i) => {
            l[i.customer.languageCode] = true;
            return l;
          }, {}),
      );
    }

    invoiceDialogsSvc.batchSendInvoices('email', params, batchParams, languages, companyId);
  };

  vm.batchSendViaPeppol = function() {
    if (vm.selectedCount() === 0) return;

    const params = { ...vm.currentSearchParams };
    const batchParams = vm.getBatchSelectionParams();
    let languages = [];
    const companyId = vm.getSingleCompanyId();

    if (!vm.selectAll) {
      languages = Object.keys(
        vm.table.rows
          .filter(el => el.selected && !el.isProcessing)
          .reduce((l, i) => {
            l[i.customer.languageCode] = true;
            return l;
          }, {}),
      );
    }

    invoiceDialogsSvc.batchSendInvoices('peppol', params, batchParams, languages, companyId);
  };
  vm.batchSendViaSendStrategy = function() {
    if (vm.selectedCount() === 0) return;

    const params = { ...vm.currentSearchParams };
    const batchParams = vm.getBatchSelectionParams();
    let languages = [];
    const companyId = vm.getSingleCompanyId();

    if (!vm.selectAll) {
      languages = Object.keys(
        vm.table.rows
          .filter(el => el.selected && !el.isProcessing)
          .reduce((l, i) => {
            l[i.customer.languageCode] = true;
            return l;
          }, {}),
      );
    }

    invoiceDialogsSvc.batchSendInvoices('sendstrategy', params, batchParams, languages, companyId);
  };

  vm.getSingleCompanyId = function() {
    if (vm.companies.length === 1) return vm.companies[0].id; //There is only 1 company, return it
    if (vm.filters && vm.filters.ownCompanies && vm.filters.ownCompanies.length === 1) {
      //Has company filter with only 1 company selected
      const company = vm.companies.find(x => x.id === vm.filters.ownCompanies[0]);
      if (company) return company.id;
    }
    if (!vm.selectAll) {
      //Select all not selected, get company id from selected invoices
      const selectedInvoiceCompanyIds = [
        ...new Set(
          vm.table.rows.filter(el => el.selected && !el.isProcessing).map(x => x.companyId),
        ),
      ];

      if (selectedInvoiceCompanyIds.length === 1) {
        // Only invoices for 1 company were selected
        return selectedInvoiceCompanyIds[0];
      }
    }
    //Multiple companies
    return null;
  };

  vm.exportRegistrations = invoice => {
    const filters = {
      [invoice.invoiceType === 6 ? 'intraCompanyInvoiceId' : 'invoiceId']: invoice.id,
      from: null,
      to: null,
    };

    return registrationService
      .createReport(filters, null, null, guid.empty)
      .$promise.then(function() {
        flySvc.success('ExportToExcelStarted');
      }, showError);
  };
  vm.canExportRegistrations = invoice => {
    if (!invoice) return false;
    if (invoice.invoiceType === 2) return false; //Advance
    if (invoice.invoiceType === 5) return false; //Free
    if (vm.details[invoice.id]?.lines) {
      //If the lines are loaded, check if there are registrations
      return vm.details[invoice.id].lines.some(x => x.hasRegistrations);
    }
    return true;
  };
  vm.getBillingInformation = invoice => {
    if (!invoice.hasBillingInformation) return;
    const relationId = invoice.customer.id;
    if (typeof vm.billingInformation[relationId] !== 'undefined') {
      invoice.showBillingInformation = true;
      return vm.billingInformation[relationId];
    }
    vm.billingInformation[relationId] = null;
    return $http
      .get(`${appUrls.api}/api/Relation/BillingInformation/${invoice.customer.id}`)
      .then(({ data }) => {
        vm.billingInformation[relationId] = data;
        if (invoice.showBillingInformation !== false) {
          invoice.showBillingInformation = true;
        }
        return data;
      }, showError);
  };
  vm.hideBillingInformation = invoice => {
    invoice.showBillingInformation = false;
  };

  //Column selection
  //List of columns that can be hidden
  vm.hideableColumns = [
    {
      key: 'isInvoice',
      label: $filter('translate')('InvoiceAbbr') + '/' + $filter('translate')('CreditNoteAbbr'),
      selected: true,
    },
    {
      key: 'assignment',
      label: $filter('translate')('Assignment'),
      selected: true,
      hiddenBySecurity: !vm.showAssignments,
    },
    {
      key: 'ownCompany',
      label: $filter('translate')('OwnCompany'),
      show: false,
      hiddenBySecurity: !vm.isMultiCompany,
    },
    { key: 'relationCode', label: $filter('translate')('RelationCode'), show: false },
    { key: 'accountingNr', label: $filter('translate')('AccountingNr'), selected: false },
    { key: 'expiryDate', label: $filter('translate')('Due Date'), selected: true },
    {
      key: 'originalAmount',
      label: $filter('translate')('OriginalAmount'),
      show: false,
    },
    {
      key: 'adjustedAmount',
      label: $filter('translate')('AdjustedAmount'),
      show: false,
    },
    { key: 'totalExclusive', label: $filter('translate')('AmountExVat'), selected: false },

    {
      key: 'amount',
      label: vm.showPaymentMonitoring()
        ? $filter('translate')('Invoice Amount')
        : $filter('translate')('Invoiced amount'),
      selected: true,
    },
    {
      key: 'paidAmount',
      label: $filter('translate')('Paid Amount'),
      selected: true,
      hiddenBySecurity: !vm.showPaymentMonitoring(),
    },
    {
      key: 'dueAmount',
      label: $filter('translate')('Balance'),
      selected: true,
      hiddenBySecurity: !vm.showPaymentMonitoring(),
    },
    { key: 'invoiceType', label: $filter('translate')('Invoice type'), selected: true },
    {
      key: 'peppol',
      label: $filter('translate')('Peppol'),
      selected: true,
      hiddenBySecurity: !$filter('tenantConfiguration')('[0,1]'),
    },
    {
      key: 'status',
      label: $filter('translate')('Invoice State'),
      selected: true,
    },
    {
      key: 'referenceYear',
      label: $filter('translate')('ReferenceYear'),
      show: false,
      hiddenBySecurity: !checkFeature('ReferenceYear'),
    },
  ];
  //Store hidden columns in object for easy use
  vm.hiddenColumns = {};

  vm.rebuildHiddenColumns = function() {
    vm.hiddenColumns = vm.hideableColumns.reduce((r, i) => {
      r[i.key] = !i.selected;
      return r;
    }, {});

    vm.countVisibleExtraColumns = 0;
    Object.keys(vm.hiddenColumns).forEach(column => {
      if (!vm.hiddenColumns[column]) vm.countVisibleExtraColumns++;
    });
  };
  vm.initHiddenColumns = function() {
    const hiddenColumns = userStorage.getItem(columnSelectionStorageKey) || [];
    if (hiddenColumns && Object.keys(hiddenColumns).length) {
      vm.hideableColumns.forEach(col => {
        if (typeof hiddenColumns[col.key] !== 'undefined') {
          col.selected = !hiddenColumns[col.key];
        }
        if (typeof col.hiddenBySecurity !== 'undefined' && !!col.hiddenBySecurity) {
          col.selected = false;
        }
      });
    }
    vm.rebuildHiddenColumns();
  };

  vm.openColumnConfigDialog = function() {
    dialogsSvc
      .showCheckboxList(
        'msgSelectTableColumns',
        vm.hideableColumns
          .filter(x => !x.hiddenBySecurity)
          .map(({ key, label, selected }) => ({ key, label, selected })),
      )
      .then(function(result) {
        if (result) {
          vm.hideableColumns.forEach(col => {
            var item = result.find(x => x.key === col.key);
            if (!item) return;
            col.selected = !!item.selected;
          });
          vm.rebuildHiddenColumns();
          //Save hidden columns
          userStorage.setItem(columnSelectionStorageKey, vm.hiddenColumns);
        }
      });
  };
  vm.updateReferenceYear = (invoice, referenceYear) => {
    if (!invoice || typeof referenceYear === 'undefined') return;
    if (invoice.referenceYear === referenceYear) return;

    return $http
      .post(`${appUrls.api}/api/invoice/ReferenceYear`, null, {
        params: {
          id: invoice.id,
          year: referenceYear,
        },
      })
      .then(
        function() {
          flySvc.success();
          return true;
        },
        function(error) {
          flySvc.error(error);
          return '';
        },
      );
  };
  vm.undoWriteOffInternally = invoice => {
    dialogsSvc
      .showYesNo('comfirmUndoWriteOffInternallyTitle', 'comfirmUndoWriteOffInternallyMessage')
      .then(function() {
        $http.post(appUrls.api + `/api/invoice/UndoWriteOffInternally/${invoice.id}`).then(
          () => {
            flySvc.success();

            if (vm.table.rows) {
              var idx = vm.table.rows.findIndex(x => x.id === invoice.id);
              if (idx >= 0) vm.table.rows.splice(idx, 1);
            }
          },
          error => {
            flySvc.error(error);
          },
        );
      });
  };

  if (vm.initFilters) {
    vm.initFilters = false;
    if (!initStateParams()) {
      setParamsFromSessionStorage();
    }
    if (vm.filters.relationId && !vm.customer) {
      initCustomer(vm.filters.relationId);
    }
  }
  vm.initHiddenColumns();
}
